import { ContentLink, EpiLink } from '@api/types';
import {
  BlockContainer,
  WarrantyList,
  WarrantyListFilters,
  WarrantyListHeader,
  WarrantyListProvider,
} from '@components';

type WarrantyListBlockProps = {
  title: string;
  contentLink?: ContentLink;
  warrantyPolicy?: EpiLink;
};

export const WarrantyListBlock: React.FC<WarrantyListBlockProps> = ({
  title,
  contentLink,
  warrantyPolicy,
}: WarrantyListBlockProps) => {
  const id = contentLink?.id?.toString() || '';
  return (
    <WarrantyListProvider id={id}>
      <BlockContainer>
        <div className='warranty-list-block'>
          <WarrantyListHeader title={title} warrantyPolicy={warrantyPolicy} />
          <WarrantyListFilters />
          <WarrantyList />
        </div>
      </BlockContainer>
    </WarrantyListProvider>
  );
};
